import { render, staticRenderFns } from "./work-views.vue?vue&type=template&id=488c564a"
import script from "./work-views.vue?vue&type=script&lang=js"
export * from "./work-views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports